export interface AttendeeRestrictions {
  minQuantity: number;
  maxQuantity: number;
  participantPrice?: number;
  adultParticipantPrice?: number;
}
